import { CompType } from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';

type SubjectData = SubjectPropertyDataState['subjectData']['editableData'];

export const getSubjectDataForCompType = (
  subjectData: SubjectData,
  compType?: CompType,
): SubjectData => {
  if (compType !== 'arv' || !subjectData.arv?.improvements) {
    return subjectData;
  }

  return {
    ...subjectData,
    improvements: {
      ...subjectData.improvements,
      ...subjectData.arv.improvements,
    },
  };
};
